import router from '@/router'
import { requireAuth } from '@/core/routerGuards'

router.addRoute({
	path: '/api_token',
	name: 'ApiToken',
	component: () => import('./pages/ApiToken.vue'),
	beforeEnter: requireAuth,
});
router.addRoute({
	path: '/api_token/new',
	name: 'ApiTokenNew',
	component: () => import('./pages/ApiTokenNew.vue'),
	beforeEnter: requireAuth,
});
